require("./src/styles/global.css");

exports.onRouteUpdate = () => {
  if (typeof window !== "undefined" && window.appInsights) {
    window.appInsights.trackPageView();
  }
};
